module.exports = "<tf-dashboard-widget-container display-mode=\"'WIDE'\" widget=\"1\">\n</tf-dashboard-widget-container>";